import React from 'react'
import { INTEGRATION_MINDBODY_CONNECTED } from 'constants/redirectEvents'
import { RegisterEventRedirectOnClick } from 'utils/eventRedirect'
import Warning from 'atoms/Warning'
import { StyledLink } from 'atoms/Link'

export default () => (
  <Warning>
    Connect Mindbody account
    {' '}
    <RegisterEventRedirectOnClick
      event={INTEGRATION_MINDBODY_CONNECTED}
      component={StyledLink}
      to="/integrations"
    >
      here
    </RegisterEventRedirectOnClick>
    {' '}
to enable this template
  </Warning>
)
